import React from 'react';
import { useCanonicalPublicStats } from '../hooks/useCanonicalPublicStats';
import BirthdayPromoBanner from './BirthdayPromoBanner';

// Use relative URL so Vite proxy handles routing to backend (avoids CORS issues)
// const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

interface NewsTickerBarProps {
  className?: string;
}

export const NewsTickerBar: React.FC<NewsTickerBarProps> = ({ className = '' }) => {
  const { stats, loading } = useCanonicalPublicStats();

  const tickerMessage = loading
    ? "🎉 Loading share data..."
    : stats
      ? `🎉 We have sold ${stats.combined.activeSharesDisplayWhole.toLocaleString('en-US').replace(/,/g, ' ')} active shares so far — ${stats.aureus.activeSharesDisplayWhole.toLocaleString('en-US').replace(/,/g, ' ')} through Aureus Alliance Holdings and ${stats.finux.activeSharesDisplayWhole.toLocaleString('en-US').replace(/,/g, ' ')} through Finux. Thank you to our shareholders for your support.`
      : '🎉 Share totals are temporarily unavailable.';

  return (
    <>
    <BirthdayPromoBanner />
    <div className={`news-ticker-container ${className}`}>
      <div className="news-ticker-wrapper">
        <div className="news-ticker-content">
          <span className="news-ticker-text">
            {tickerMessage}
          </span>
        </div>
      </div>
      
      <style>{`
        .news-ticker-container {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 46;
          background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
          border-bottom: 2px solid #f59e0b;
          height: 40px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
        }

        .news-ticker-wrapper {
          height: 100%;
          display: flex;
          align-items: center;
          position: relative;
          overflow: hidden;
        }

        .news-ticker-content {
          display: flex;
          align-items: center;
          height: 100%;
          white-space: nowrap;
          animation: scroll-left 30s linear infinite;
        }

        .news-ticker-text {
          color: #ffffff;
          font-size: 14px;
          font-weight: 500;
          padding: 0 50px;
          display: inline-block;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
        }

        @keyframes scroll-left {
          0% {
            transform: translateX(100vw);
          }
          100% {
            transform: translateX(-100%);
          }
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .news-ticker-container {
            height: 35px;
          }
          
          .news-ticker-text {
            font-size: 12px;
            padding: 0 30px;
          }
          
          @keyframes scroll-left {
            0% {
              transform: translateX(100vw);
            }
            100% {
              transform: translateX(-100%);
            }
          }
        }

        /* Ensure smooth animation */
        .news-ticker-content {
          will-change: transform;
        }

        /* Add subtle gradient overlay for professional look */
        .news-ticker-container::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(90deg, 
            rgba(31, 41, 55, 0.8) 0%, 
            rgba(31, 41, 55, 0.2) 20%, 
            rgba(31, 41, 55, 0.2) 80%, 
            rgba(31, 41, 55, 0.8) 100%
          );
          pointer-events: none;
          z-index: 1;
        }

        .news-ticker-content {
          position: relative;
          z-index: 2;
        }
      `}</style>
    </div>
    </>
  );
};

export default NewsTickerBar;
